import React from "react";

import Button from "@busbud/design-system-components/dist/Button";
import AngleDownSM from "@busbud/design-system-components/dist/Icons/AngleDown/SM";
import Label from "@busbud/design-system-components/dist/Label";
import Stack from "@busbud/design-system-components/dist/Stack";

import { CustomNativeSelect } from "../../custom-native-select";

const CURRENT_YEAR = new Date().getFullYear();

function generateYears(start_year: number): number[] {
  const years: number[] = [];

  while (start_year <= CURRENT_YEAR) {
    years.push(start_year);
    start_year++;
  }

  return years.reverse();
}

interface Props {
  onYearSelected: (year: number) => void;
  selected_year?: number;
  start_year: number;
}

export const TransactionsFilter: React.FC<Props> = ({
  onYearSelected,
  selected_year = CURRENT_YEAR,
  start_year
}) => {
  const years_options = generateYears(start_year);

  const selectYear = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (event) {
      onYearSelected(parseInt(event.target.value));
    }
  };

  return (
    <Stack spacing={2} justifyContent="space-between" alignItems="center">
      <Label size="lg" fontWeight="bold">
        View transactions
      </Label>

      <CustomNativeSelect
        defaultValue={selected_year}
        onChange={selectYear}
        Trigger={
          <div>
            <Button color="tertiary" endIcon={<AngleDownSM />}>
              {`In ${selected_year}`}
            </Button>
          </div>
        }
      >
        {years_options.map(option => (
          <option
            key={option}
            value={option}
            selected={selected_year === option}
          >
            {option}
          </option>
        ))}
      </CustomNativeSelect>
    </Stack>
  );
};
